import { MapContainer, Marker, TileLayer } from "react-leaflet";

import type { InnointelCompany, MapBounds } from "components/innointel/types";
import { hasMapCoordinates, toMapBounds } from "components/innointel/types";

type CompanyMapProps = { company: InnointelCompany };

const CompanyMap = ({ company }: CompanyMapProps) => {
  if (!hasMapCoordinates(company)) {
    return null;
  }

  const coordinates = company.location.search.coordinates;
  const position: [number, number] = [
    coordinates.latitude,
    coordinates.longitude,
  ];
  const bounds = toMapBounds(
    (coordinates as { viewport?: { latitude?: number; longitude?: number }[] })
      .viewport,
  );

  const mapProps =
    bounds ? { bounds: bounds as MapBounds } : { zoom: 10, center: position };

  return (
    <MapContainer
      key={company._id}
      style={{ width: "300px", height: "200px", zIndex: 1 }}
      {...mapProps}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Marker position={position} />
    </MapContainer>
  );
};

export default CompanyMap;
